import React from "react";
import { Link } from "react-router-dom";

export const Marquee = ({ items, dark = false }) => {
  const row = [...items, ...items];
  return (
    <div
      className={`overflow-hidden border-y ${dark ? "bg-[#082838] border-white/10" : "bg-[#EBF3F8] border-[#0A2B3D]/10"}`}
      data-testid="editorial-marquee"
    >
      <div className="flex whitespace-nowrap animate-marquee py-5">
        {row.map((item, i) => (
          <Link
            key={`${item.label}-${i}`}
            to={item.to}
            data-testid={`marquee-link-${item.label.toLowerCase().replace(/[^a-z]+/g, "-")}-${i < items.length ? "a" : "b"}`}
            className="flex items-center group"
            aria-label={item.label}
          >
            <span
              className={`font-serif text-base sm:text-xl md:text-2xl italic px-6 md:px-8 transition-colors duration-300 ${
                dark ? "text-white/70 group-hover:text-[#3E9BDC]" : "text-[#0A2B3D] group-hover:text-[#3E9BDC]"
              }`}
            >
              {item.label}
            </span>
            <span className="w-1.5 h-1.5 rotate-45 bg-[#3E9BDC] transition-transform duration-300 group-hover:scale-150" />
          </Link>
        ))}
      </div>
    </div>
  );
};
